import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar, Notify } from 'quasar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { MotionPlugin } from '@vueuse/motion';
import * as Sentry from '@sentry/vue';
import i18n from './i18n';
import Toast, { POSITION } from 'vue-toastification';

import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import 'vue-toastification/dist/index.css';

import App from './App.vue';
import router from './router';

import './assets/main.scss';

import setPrimeVue from './middlewares/primeVue';

const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = (event) => {
      if (!(el == event.target || el.contains(event.target))) {
        binding.value();
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted: (el) => {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};

library.add(faBars);

export const app = createApp(App);

app.directive('click-outside', clickOutside);

Sentry.init({
  app,
  dsn: 'https://1f71fac3500febd1dacbf02a00bdd179@o4507373868810240.ingest.de.sentry.io/4507373870448720',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/dev.wspomnieniazwesela\.pl/,
    /^https:\/\/fix.wspomnieniazwesela\.pl/,
    /^https:\/\/app.wspomnieniazwesela\.pl/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
});

app.use(Quasar, {
  plugins: {
    Notify,
  },
});

app.use(createPinia());
app.use(i18n);
app.use(router);
app.use(MotionPlugin);
app.use(Toast, {
  transition: 'Vue-Toastification__fade',
  position: POSITION.BOTTOM_CENTER,
  hideProgressBar: true,
  timeout: 2000,
});
setPrimeVue(app);

app.component('Icon', FontAwesomeIcon);

app.mount('#app');
